import type {supplierNotesRouteApi} from "./-route-api";
import {tableURLStateSchema} from "@project/components/data-display/table";
import {z} from "zod";

export const supplierNotesSearchSchema = tableURLStateSchema.extend({
  includeDeleted: z.boolean().optional().default(false),
});
export type SupplierNotesSearch = z.output<typeof supplierNotesSearchSchema>;
export type SupplierNotesNavigateFn = ReturnType<typeof supplierNotesRouteApi.useNavigate>;
